import { render, staticRenderFns } from "./UiMenuOption.vue?vue&type=template&id=050a65dc"
import script from "./UiMenuOption.vue?vue&type=script&lang=js"
export * from "./UiMenuOption.vue?vue&type=script&lang=js"
import style0 from "./UiMenuOption.vue?vue&type=style&index=0&id=050a65dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports